import { Modal } from "antd"
import { ServiceContract } from "src/common/models/contract"
import { FormActionButtons } from "src/components/FormActionButtons"
import { SystemDescriptions } from "src/common/descriptions"
import { ContractConfirmationComponent } from "./ContractConfirmationComponent"
import { ContractStatusBadge } from "./ContractConfirmationComponent/ContractStatusBadge"

interface Props {
    open: boolean
    onCancel: VoidFunction
    onAccept: VoidFunction
    okText: string
    cancelText: string
    currentContract: Partial<ServiceContract>
    readOnly?: boolean
    type: "SERVICE_CONTRACT" | "PAYABLE_CONTRACT"
}

export const ContractConfirmation = (props: Props) => {

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    const renderButtons = () => (
        <FormActionButtons
            cancelText={props.cancelText}
            actionText={props.okText}
            onCancel={props.onCancel}
            onAccept={props.onAccept}
        />
    )

    const renderTitle = () => {
        return <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "8px" }}>
            {
                !props.readOnly
                    ? descriptions.CONFIRM_MODAL.TITLE
                    : props.type === "PAYABLE_CONTRACT"
                        ? descriptions.PAYABLE_DETAIL_TITLE
                        : descriptions.SERVICE_DETAIL_TITLE
            }
            {
                props.currentContract?.id &&
                <ContractStatusBadge
                    isActive={!!props.currentContract.isActive}
                    size="sm"
                />
            }
        </div>
    }

    return (
        <Modal
            title={renderTitle()}
            centered
            open={props.open}
            width={1000}
            onOk={props.onAccept}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={!!props.readOnly}
            zIndex={1200}
            getContainer={false}
            onCancel={props.readOnly ? props.onCancel : undefined}
        >
            <ContractConfirmationComponent
                currentContract={props.currentContract}
                type={props.type}
                readOnly={props.readOnly}
            />
            {!props.readOnly && renderButtons()}
        </Modal>
    )
}
